import { EventTabIds } from '@tribeplatform/react-components/Event'
import { I18nShape } from '@tribeplatform/react-components/i18n'

import { EventsListBlockView } from '../types.js'

export const tabViewsFactory: (intl: I18nShape) => EventsListBlockView[] = ({
  $t,
}) => [
  {
    id: EventTabIds.Upcoming,
    name: $t({
      defaultMessage: 'Upcoming',
      id: 'EventsListBlock.Settings.TabViews.Upcoming',
    }),
    style: 'card',
    fields: [],
    enabled: true,
  },
  {
    id: EventTabIds.Past,
    name: $t({
      defaultMessage: 'Past',
      id: 'EventsListBlock.Settings.TabViews.Past',
    }),
    style: 'card',
    fields: [],
    enabled: true,
  },
]
